import React from 'react'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { ThemeContextProvider } from 'contexts/ThemeContext'
import { RefreshContextProvider } from 'contexts/RefreshContext'
import store from 'state'

const Providers: React.FC = ({ children }) => {
  return (
      <Provider store={store}>
          <HelmetProvider>
            <ThemeContextProvider>
                <RefreshContextProvider>
                  {children}
                </RefreshContextProvider>
            </ThemeContextProvider>
          </HelmetProvider>
      </Provider>
  )
}

export default Providers
